import { TMCTableModule } from '@sdbn/appclient';
import { CompleteUmbrueckungDialogComponent } from './component/complete-umbrueckung-dialog.component';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { BeginUmbrueckungDialogComponent } from './component/begin-umbrueckung-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';


@NgModule({
  declarations: [BeginUmbrueckungDialogComponent, CompleteUmbrueckungDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule
  ]
})
export class TransportUmbrueckungModule { }
